import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  title: string = '';
  config = { closeButton: true, positionClass: 'toast-bottom-right' };
  constructor(private toastrService: ToastrService) {}

  showSuccess(message: string): void {
    this.toastrService.clear();
    this.toastrService.success(message, this.title, this.config);
  }

  showError(message: string): void {
    this.toastrService.clear();
    this.toastrService.error(message, this.title, this.config);
  }

  showInfo(message: string): void {
    this.toastrService.info(message, this.title, this.config);
  }

  showWarning(message: string): void {
    this.toastrService.warning(message, this.title, this.config);
  }

  showCustomError(message: string, title: string): void {
    this.toastrService.error(title, message, this.config);
  }

  showCustomSuccess(message: string, title: string): void {
    this.toastrService.success(title, message, this.config);
  }

  showCustomSuccess2(message: string): void {
    const config = {
      closeButton: false,
      positionClass: 'toast-bottom-right',
      toastClass: 'custom-toast-success',
    };
    this.toastrService.success('', message, config);
  }
}
